import React from "react";
interface RelationsIconProps {
  size?: number;
  color?: string;
}
const ReleaseIdIcon = ({
  size = 24,
  color = "#79808A",
}: RelationsIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.616 16V10.897H14.379V16H13.616ZM15.6189 16V10.897H17.6839C19.1539 10.897 19.9939 11.919 19.9939 13.452C19.9939 14.985 19.1539 16 17.6839 16H15.6189ZM16.3819 15.342H17.5719C18.5589 15.342 19.2099 14.733 19.2099 13.438C19.2099 12.143 18.5519 11.555 17.5719 11.555H16.3819V15.342Z"
        fill={color}
      />
      <path
        d="M3 11L6.99575 13L11 11M3 13L6.99575 15L11 13M3 9.0785L6.99975 11L11 9.0785L6.99975 7L3 9.0785Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ReleaseIdIcon;
